import { render } from "./OptoutsComponent.vue?vue&type=template&id=2eb08d01&scoped=true"
import script from "./OptoutsComponent.vue?vue&type=script&lang=js"
export * from "./OptoutsComponent.vue?vue&type=script&lang=js"

import "./OptoutsComponent.vue?vue&type=style&index=0&id=2eb08d01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb08d01"]])

export default __exports__